import { API_URLS } from "../constants";
import { getRequest, postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { MARKETING_ATTRIBUTION, MARKETING_EXTENDED_REPORT } = API_URLS;

const getMarketingAttributionData = (body) => {
  return postRequest(
    MARKETING_ATTRIBUTION.GET_ATTRIBUTION_SALES_DATA,
    body
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};
const getMarketingAttributionGraphData = (body) => {
  return postRequest(MARKETING_EXTENDED_REPORT.GRAPH_DATA, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};
const getMarketingAttributionPaginatedData = (body) => {
  return postRequest(MARKETING_EXTENDED_REPORT.PAGINATED_DATA, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};
const getMarketingAttributionReportBody = (deliveryId, taskQueueId) => {
  return getRequest(
    `${MARKETING_EXTENDED_REPORT.GET_DELIVERY_BODY}/${deliveryId}/${taskQueueId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const marketingAttributionServices = {
  getMarketingAttributionData,
  getMarketingAttributionGraphData,
  getMarketingAttributionReportBody,
  getMarketingAttributionPaginatedData,
};
